export enum StepStatusEnum {
  Unknown = 0,
  ToSign = 1,
  Signing = 2,
  Signed = 3,
  ToComplete = 4,
  Incomplete = 5,
  Completed = 6,
  ToAdd = 7,
  Added = 8,
  Expired = 9,
}
